import React, { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";

function DashboardLayout({ children }) {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const [openMenu, setOpenMenu] = useState(null);
  let user = null;
  try {
    user = JSON.parse(localStorage.getItem("user"));
  } catch (error) {
    user = null;
  }
  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (screenSize > 768 && mobileMenu) {
      setMobileMenu(false);
    }
  }, [screenSize, mobileMenu]);

  const logout = () => {
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("user");
    localStorage.removeItem("adminLastActiveAt");
    const basePath = window.location.pathname.includes("/finaloutput/public_html")
      ? "/finaloutput/public_html"
      : "";
    window.location.href = `${basePath}/administrator`;
  };

  return (
    <div
      style={{
        display: "flex",
        minHeight: "100vh",
        background: "radial-gradient(circle at top left, #dbeafe 0%, #f8fafc 34%, #fff7ed 100%)",
      }}
    >

      {/* SIDEBAR */}
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        screenSize={screenSize}
        mobileMenu={mobileMenu}
        setMobileMenu={setMobileMenu}
        openMenu={openMenu}
        setOpenMenu={setOpenMenu}
      />

      {/* MAIN */}
      <div
        style={{
          flex: 1,
          minHeight: "100vh",
          marginLeft:
            screenSize <= 768
              ? "0"
              : collapsed
              ? "70px"
              : "240px",
        }}
      >

        <Topbar
          setMobileMenu={setMobileMenu}
          logout={logout}
          user={user}
          screenSize={screenSize}
        />

        {/* PAGE CONTENT */}
        <div style={{ padding: screenSize <= 768 ? "14px" : "24px" }}>
          {children}
        </div>

      </div>
    </div>
  );
}

export default DashboardLayout;
